module.exports = __webpack_public_path__ + "img/ci_color.dd188239.svg";